import { ToolDefinition } from "../types";

/**
 * Python execution tool — backed by Pyodide loaded from a CDN at first use.
 * We intentionally lazy-load the executor so users who never invoke Python
 * don't pay the ~15MB Pyodide download.
 */

export const pythonToolDefinitions: ToolDefinition[] = [
  {
    name: "execute_python",
    description:
      "Execute Python code in a Pyodide (WASM) sandbox running in the browser. " +
      "numpy, pandas, scipy and matplotlib are available. Use this for: " +
      "ad-hoc analysis on data returned from other tools, statistical tests, " +
      "or producing simple plots. " +
      "\n\nIMPORTANT: " +
      "(1) The print() output is captured and returned to you. " +
      "(2) To plot, use matplotlib with the Agg backend; the executor will " +
      "embed any figures as base64 PNGs in the result. " +
      "(3) Previous tool results are NOT automatically available — pass " +
      "needed data as Python literals in the code, or rely on the user's " +
      "follow-up questions.",
    input_schema: {
      type: "object",
      properties: {
        code: {
          type: "string",
          description: "Python code to execute. Should be valid Pyodide-compatible Python.",
        },
        description: {
          type: "string",
          description:
            "A short human-readable description of what this code does, " +
            "shown in the status history.",
        },
      },
      required: ["code"],
    },
  },
];

export async function executePython(
  input: Record<string, unknown>,
): Promise<unknown> {
  const code = typeof input.code === "string" ? input.code : null;
  if (!code) return { success: false, error: "code is required" };

  const { runPython } = await import("../pyodide/pyodideExecutor");
  return runPython(code);
}
